import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "pme-info-message",
    templateUrl: "./info-message.component.html",
    styleUrls: ["./info-message.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InfoMessageComponent implements OnInit {
  @Input() type: string;
  @Input() title: string;

  constructor() {}

  ngOnInit() {
  }

  getMessageTitleClass() {
    switch(this.type) {
      case 'error':
        return 'error-title';

      case 'warn':
        return 'warn-title';

      case 'success':
        return 'succ-title'

      case 'info':
        return 'info-title'
    }
  }

  getIconContent() {
    switch(this.type) {
      case 'error':
        return 'error';

      case 'warn':
        return 'warning';

      case 'success':
        return 'check_circle'

      case 'info':
        return 'info'
    }
  }

  getInfoMessageIconClass() {
    switch(this.type) {
      case 'error':
        return 'error-icon';

      case 'warn':
        return 'warn-icon';

      case 'success':
        return 'succ-icon'

      case 'info':
        return 'info-icon'
    }
  }

  getInfoMessageClass() {
    switch(this.type) {
      case 'error':
        return 'error-info-message';

      case 'warn':
        return 'warn-info-message';

      case 'success':
        return 'succ-info-message'

      case 'info':
        return 'info-info-message'
      case 'new-info':
        return 'new-info-info-message'
    }
  }
}
